<template>
  <div class="workSpace">
    <!-- 左侧内容 -->
    <div class="leftContent">
      <!-- 头部按钮 -->
      <div class="buttons">
        <el-button type="primary" size="small" icon="el-icon-circle-plus-outline" @click="addTreeNode(1)">产品配置</el-button>
        <el-button v-if="currentTreeNode.workSpaceName==='WorkSpaces'" plain type="primary" size="small" icon="el-icon-circle-plus-outline"
          @click="addTreeNode(2)">
          工作空间
        </el-button>
        <el-button v-if="currentTreeNode.workSpaceName==='WorkSets'" plain type="primary" size="small" icon="el-icon-circle-plus-outline"
          @click="addTreeNode(3)">
          工作集
        </el-button>
        <el-button v-if="currentTreeNode.workSpaceType&&currentTreeNode.workSpaceType!==0" plain type="primary" size="small" @click="updateTreeNode">
          修改
        </el-button>
        <el-button v-if="currentTreeNode.workSpaceType&&currentTreeNode.workSpaceType!==0" plain type="primary" size="small" @click="deleTreeNode">
          删除
        </el-button>
      </div>
      <!-- 树 -->
      <div v-loading="leftTreeLoading" class="tree" element-loading-text="数据加载中...">
        <el-tree ref="leftTree" :data="treeData" :props="defaultProps" highlight-current node-key="workSpaceId"
          default-expand-all :expand-on-click-node="false" @node-click="nodeClick">
          <template #default="{ data, node }">
            <span :style="{'padding-right': node.level > 1 ? '35px' : '0'}" class="left_tree_item">
              <img :src="getIcon(node.level,data)" style="margin-right: 6px" alt="图标" />
              <span :title="data.remark?data.workSpaceName+';'+data.remark:data.workSpaceName" class="textAll">{{ data.workSpaceName }}</span>
            </span>
          </template>
        </el-tree>
      </div>
    </div>
    <!-- 右侧内容 -->
    <div class="rightContent">
      <!-- 头部按钮 -->
      <div class="buttons">
        <el-dropdown trigger="click" placement="bottom-start" @command="isFileOrFolder">
          <el-button size="small" type="primary" class="upload" icon="el-icon-upload2" :disabled="!currentTreeNode.workSpaceId">
            上传
          </el-button>
          <el-dropdown-menu slot="dropdown" style="width:94px;">
            <el-dropdown-item command="file" style="text-align: center !important;">
              文件
            </el-dropdown-item>
            <!-- 上传文件夹同新建文件夹的权限 -->
            <el-dropdown-item command="folder" style="text-align: center !important;">
              文件夹
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button :disabled="!selectionList.length" style="margin-left: 10px;" type="primary" size="small" plain @click="reName">重命名</el-button>
        <el-button :disabled="!selectionList.length" type="danger" plain size="small" @click="deleteRightSelection">
          删除
        </el-button>
      </div>
      <!-- 中间内容 -->
      <div class="titleContent">
        <div class="titleContent_left">
          <div>
            <el-button :disabled="!breadcrumbList.length || breadcrumbList.length==1 " plain type="primary" size="small"
              @click="goTopLevel">
              <i class="el-icon-return" style="margin-right:3px"></i>
              返回上一级
            </el-button>
          </div>
          <div class="breadcrumb_list">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item v-for="(item,index ) in breadcrumbList" :key="item.workSpaceId">
                <span :class="{'active' :index=== breadcrumbList.length - 1 }"
                  :title="breadTitle(breadcrumbList, item)" @click="index !== breadcrumbList.length - 1 && clickBread(item)">
                  {{ item.workSpaceName }}
                </span>
              </el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </div>

        <div>
          <el-input v-model="keyWords" placeholder="请输入文件/文件夹名称" suffix-icon="el-icon-search" size="small"
            style="width: 200px;"></el-input>
        </div>
      </div>
      <!-- 表格内容 -->
      <div v-loading="rightListLoading" class="table" element-loading-text="数据加载中...">
        <el-table :data="tableData" border height="calc(100vh - 220px)" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55" align="center"></el-table-column>
          <el-table-column label="名称" prop="folderName">
            <template slot-scope="{ row }">
              <div style="display: flex; align-items: center;cursor: pointer;" @click="getDocList(row)">
                <img :src="className(row)"
                  style=" flex-shrink: 0; margin:0 5px; -webkit-user-drag: none; -moz-user-select: none;-ms-user-select: none; -khtml-user-select: none; user-select: none; " />
                <span style="width: 80%">{{ row.folderName }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="修改时间" prop="checkInDate" align="center"></el-table-column>
          <el-table-column label="修改人" prop="checkInUser" align="center"></el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 左侧新增弹框 -->
    <el-dialog v-dialogDrag :title="'新增'+addDialogTitle" :visible.sync="addDialog" width="30%" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form ref="addFormData" :model="formData" :rules="rules" size="small">
        <el-row>
          <el-col :span="24">
            <el-form-item label="名称：" prop="workSpaceName">
              <el-input ref="workSpaceName" v-model="formData.workSpaceName" placeholder="请输入" maxlength="50" show-word-limit class="workSpaceNameStyle"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注：">
              <el-input v-model="formData.remark" type="textarea" placeholder="请输入" maxlength="200" show-word-limit
                rows="5">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAddDialog">取 消</el-button>
        <el-button type="primary" size="small" @click="submitAddFormData">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 左侧修改弹框 -->
    <el-dialog v-dialogDrag :title="'修改'+updateDialogTitle" :visible.sync="updateDialog" width="30%" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form ref="updateFormData" :model="formData" :rules="rules" size="small">
        <el-row>
          <el-col :span="24">
            <el-form-item label="名称：" prop="workSpaceName">
              <el-input v-model="formData.workSpaceName" placeholder="请输入" maxlength="50" show-word-limit class="workSpaceNameStyle"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注：">
              <el-input v-model="formData.remark" type="textarea" placeholder="请输入" maxlength="200" show-word-limit
                rows="5">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeUpdateDialog">取 消</el-button>
        <el-button type="primary" size="small" @click="submitUpdateFormData">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 右侧表格数据重命名弹框 -->
    <el-dialog v-dialogDrag title="重命名" :visible.sync="reNameDialog" width="30%" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form ref="rowFormData" :model="rowData" :rules="rowRules" size="small">
        <el-row>
          <el-col :span="24">
            <el-form-item label="名称：" prop="workSpaceName">
              <el-input v-model="rowData.workSpaceName" placeholder="请输入" maxlength="80" show-word-limit class="workSpaceNameStyle"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeReNameDialog">取 消</el-button>
        <el-button type="primary" size="small" @click="submitRowData">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { filePreviewV1, tableRowIcon } from "@/CommonDP/utils/docPublic";
import workSpaceService from "@/CommonDP/service/workSpace-service";
import { mapState } from "vuex";
import { uploader } from "@/CommonDP/utils/IUploader/dp";
const FROMDATA = () => ({
  workSpaceName: "",
  workSpaceType: null,
  workSpaceId: "",
  parentId: 0,
  enterpriseId: "",
  remark: ""
});
const ROWDATA = () => ({
  workSpaceName: "",
  workSpaceId: "",
  isFolder: "",
  prjId: ""
});

export default {
  name: "WorkSpace",
  components: { },
  mixins: [],
  props: {},
  data() {
    return {
      prjId: "",
      defaultProps: { children: "children", label: "workSpaceName" },
      keyWords: "",
      leftTreeLoading: false,
      treeData: [], // 树
      rightListLoading: false,
      tableData: [], // 表格
      neverChangeList: [], // 永不改变的数组 用来搜索
      rules: {
        workSpaceName: [{ required: true, message: "请输入名称", trigger: "chage" }]
      },
      addDialog: false,
      addDialogTitle: "",
      updateDialog: false,
      updateDialogTitle: "",
      formData: FROMDATA(),
      currentTreeNode: {}, // 当前选中树节点
      selectionList: [],
      reNameDialog: false,
      rowData: ROWDATA(),
      rowRules: {
        workSpaceName: [{ required: true, message: "请输入名称", trigger: "chage" }]
      },
      breadcrumbList: []
    };
  },
  computed: {
    ...mapState({
      enterpriseId: state => state.enterprise.enterpriseId,
      prjInfo: state => state.projectMg.prjObj,
      refreshKey: state => state.XtDesign.refreshKey
    })
  },
  watch: {
    keyWords(val) {
      this.selectionList = [];
      if (val === "") {
        this.getRightList();
      } else {
        const list = this.neverChangeList;
        this.tableData = list.filter(item => this.filterKeyword(item, val));
      }
    },
    refreshKey(newValue, oldValue) {
      this.getRightList();
    }
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    breadTitle(breadArr, item) {
      const titleArr = [];
      for (let i = 0; i < breadArr.length; i++) {
        titleArr.push(breadArr[i].workSpaceName);
        if (breadArr[i].workSpaceId === item.workSpaceId) {
          break;
        }
      }
      return titleArr.join("/");
    },
    async init() {
      await this.getWorkSpaceDocByEnterpriseId();
      await this.getTree();
    },
    async getWorkSpaceDocByEnterpriseId() {
      const res = await workSpaceService.getWorkSpaceDocByEnterpriseId(this.enterpriseId);
      this.prjId = res.data;
    },
    async getTree() {
      this.currentTreeNode = {};
      this.breadcrumbList = [];
      this.neverChangeList = [];
      this.tableData = [];
      try {
        this.leftTreeLoading = true;
        const res = await workSpaceService.getTree(this.enterpriseId);
        this.treeData = res.data || [];
        if (this.treeData.length) {
          this.$nextTick(async () => {
            this.currentTreeNode = this.treeData[0];
            this.breadcrumbList.push(this.treeData[0]);
            this.$refs.leftTree.setCurrentKey(this.treeData[0].workSpaceId);
            this.getRightList();
          });
        }
      } catch (e) {
        console.log(e);
      } finally {
        this.leftTreeLoading = false;
      }
    },

    async getRightList() {
      try {
        this.rightListLoading = true;
        const params = {
          folderId: this.currentTreeNode.workSpaceId,
          isRead: 1,
          priviAll: "1",
          noRightClickMenu: true,
          prjId: this.prjId
        };
        const res = await workSpaceService.getRightList(params);
        this.tableData = res.data || [];
        this.neverChangeList = res.data || [];
      } catch (e) {
        console.log(e);
      } finally {
        this.rightListLoading = false;
      }
    },

    async getDocList(row) {
      // 统一面包屑格式
      row.workSpaceId = row.folderId;
      row.workSpaceName = row.folderName;
      // console.log(row);

      const { isFolder } = row;
      if (isFolder === 1) {
        try {
          this.rightListLoading = true;
          const params = {
            folderId: row.folderId,
            isRead: 1,
            priviAll: "1",
            noRightClickMenu: true,
            prjId: this.prjId
          };
          const res = await workSpaceService.getRightList(params);
          this.tableData = res.data || [];
          this.neverChangeList = res.data || [];
          this.$nextTick(async () => {
            // 不在左侧树上展示的文件夹 不能走这里的逻辑 需要另外写
            // 遍历树找到当前进入的节点
            // this.currentTreeNode = this.filterTree(this.treeData, row.folderId)[0];
            // this.$refs.leftTree.setCurrentKey(row.folderId);
            // 获取面包屑集合
            // const arr = this.get_breadcrumbList(this.treeData, data => data.workSpaceId === row.folderId);
            // console.log("获取面包屑集合", arr);
            // this.breadcrumbList = arr;

            this.currentTreeNode = row;
            this.$refs.leftTree.setCurrentKey(row.folderId);
            this.breadcrumbList.push(row);
            // console.log("获取面包屑集合", this.breadcrumbList);
          });
        } catch (e) {
          console.log(e);
        } finally {
          this.rightListLoading = false;
        }
      } else {
        this.onLineView(row);
      }
    },

    async onLineView(row) {
      const { status, folderId: fileId, fileVersion: versionId, parentId, fileType } = row;
      const data = {
        status, fileId, versionId, parentId, fileType
      };
      filePreviewV1(data, this.tableData);
    },

    filterTree(tree, folderId, arr = []) {
      for (const item of tree) {
        if (item.workSpaceId === folderId) {
          arr.push(item);
        }
        if (item.children && item.children.length) {
          this.filterTree(item.children, folderId, arr);
        }
      }
      return arr;
    },

    /**
     * 显示层级数据
     * @param tree {Array} 树数据
     * @param func {Function} 回调函数
     * @param field {String} 字段名称
     * @param path {Array} 路径数据
     * @returns {*[]|[]|*}
     */
    get_breadcrumbList(tree, func, field = "", path = []) {
      if (!tree) return [];
      for (const data of tree) {
        field === "" ? path.push(data) : path.push(data[field]);
        if (func(data)) return path;
        if (data.children) {
          const findChildren = this.get_breadcrumbList(data.children, func, field, path);
          if (findChildren.length) return findChildren;
        }
        path.pop();
      }
      return [];
    },

    // 返回上一级
    goTopLevel() {
      this.breadcrumbList = this.breadcrumbList.splice(0, this.breadcrumbList.length - 1);
      this.$nextTick(() => {
        const params = this.breadcrumbList[this.breadcrumbList.length - 1];
        this.currentTreeNode = params;
        this.$refs.leftTree.setCurrentKey(params.workSpaceId);
        this.getRightList();
      });
    },

    // 面包屑点击
    clickBread(row) {
      const index = this.breadcrumbList.findIndex(ele => ele.workSpaceId === row.workSpaceId);
      this.breadcrumbList = this.breadcrumbList.splice(0, index + 1);
      this.$nextTick(() => {
        this.currentTreeNode = row;
        this.$refs.leftTree.setCurrentKey(row.workSpaceId);
        this.getRightList();
      });
    },

    nodeClick(data, node) {
      // console.log("当前选中树节点", data);
      this.currentTreeNode = data;

      // 获取面包屑集合
      const arr = this.get_breadcrumbList(this.treeData, data => data.workSpaceId === this.currentTreeNode.workSpaceId);
      // console.log("获取面包屑集合", arr);
      this.breadcrumbList = arr;

      this.selectionList = [];
      this.getRightList();
      // console.log(data, node);
      this.$nextTick(() => {
        this.$refs.leftTree.setCurrentKey(data.workSpaceId);
      });
    },
    // 添加树节点
    addTreeNode(type) {
      this.clearFormData();
      if (type === 1) {
        this.formData.workSpaceType = 1;
        this.addDialogTitle = "产品配置";
      } else if (type === 2) {
        this.formData.workSpaceType = 2;
        this.addDialogTitle = "工作空间";
      } else if (type === 3) {
        this.formData.workSpaceType = 3;
        this.addDialogTitle = "工作集";
      }
      this.addDialog = true;
      this.$nextTick(() => {
        this.$refs.workSpaceName.focus();
        this.$refs.addFormData.clearValidate();
      });
    },
    // 提交添加的树节点
    async submitAddFormData() {
      this.$refs.addFormData.validate(async valid => {
        if (valid) {
          if (this.formData.workSpaceType !== 1) this.formData.parentId = this.currentTreeNode.workSpaceId;
          this.formData.enterpriseId = this.enterpriseId;
          await workSpaceService.createTree(this.formData);
          this.$success("添加节点成功！");
          this.closeAddDialog();
          this.getTree();
        } else {
          return false;
        }
      });
    },
    // 关闭添加弹框
    closeAddDialog() {
      this.addDialogTitle = "";
      this.addDialog = false;
      this.clearFormData();
    },
    // 修改树节点
    updateTreeNode() {
      if (this.currentTreeNode.workSpaceType === 1) {
        this.updateDialogTitle = "产品配置";
      } else if (this.currentTreeNode.workSpaceType === 2) {
        this.updateDialogTitle = "工作空间";
      } else if (this.currentTreeNode.workSpaceType === 3) {
        this.updateDialogTitle = "工作集";
      }
      this.formData = JSON.parse(JSON.stringify(this.currentTreeNode));
      this.updateDialog = true;
      this.$nextTick(() => {
        this.$refs.updateFormData.clearValidate();
      });
    },
    // 提交修改的树节点
    submitUpdateFormData() {
      this.$refs.updateFormData.validate(async valid => {
        if (valid) {
          await workSpaceService.updateTree(this.formData);
          this.$success("修改节点成功！");
          this.closeUpdateDialog();
          this.getTree();
        } else {
          return false;
        }
      });
    },
    // 关闭修改弹框
    closeUpdateDialog() {
      this.updateDialogTitle = "";
      this.updateDialog = false;
      this.clearFormData();
    },
    // 删除树节点
    async deleTreeNode() {
      // console.log(this.currentTreeNode);
      this.$confirm(`此操作将删除 ${this.currentTreeNode.workSpaceName} 节点，是否继续？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
        closeOnPressEscape: false
      }).then(() => {
        const params = {
          workSpaceId: this.currentTreeNode.workSpaceId
        };
        workSpaceService.deleteTree(params).then(res => {
          if (res.result === "0") {
            this.$success("删除节点成功！");
            this.getTree();
          }
        });
      });
    },
    // 清空表单
    clearFormData() {
      this.formData = FROMDATA();
    },
    handleSelectionChange(val) {
      this.selectionList = val;
    },
    // 上传
    async isFileOrFolder(type) {
      const params = {
        prjId: this.prjId,
        folderId: this.currentTreeNode.workSpaceId,
        versionId: ""
      };
      await uploader.open({ params, multiple: true, showPanel: true, once: false, isDirectory: type !== "file" });
      this.getRightList();
    },
    // 重命名
    reName() {
      const { selectionList } = this;
      const fileDel = selectionList.some(item => item.isSys === 1);
      if (fileDel) {
        return this.$message.warning("您选择的文件中包含没有重命名权限的文件，请重新选择");
      }
      if (selectionList.length !== 1) return this.$warn("请选择一条数据进行重命名！");
      if (selectionList[0].isFolder === 1) {
        this.rowData.workSpaceName = selectionList[0].folderName;
      } else {
        const typeIndex = selectionList[0].folderName.lastIndexOf(".");
        const newName = selectionList[0].folderName.substring(0, typeIndex);
        this.rowData.workSpaceName = newName;
      }

      this.rowData.workSpaceId = selectionList[0].folderId;
      this.rowData.isFolder = selectionList[0].isFolder;
      this.rowData.prjId = this.prjId;
      this.reNameDialog = true;
    },
    submitRowData() {
      this.$refs.rowFormData.validate(async valid => {
        if (valid) {
          let name = this.rowData.workSpaceName.replace(/\s*/g, "");
          if (this.selectionList[0].isFolder === 0) {
            const fileTypeArr = this.selectionList[0].folderName.split(".");
            name = `${name}.${fileTypeArr[fileTypeArr.length - 1]}`;
          }
          this.rowData.workSpaceName = name;
          await workSpaceService.reName(this.rowData);
          this.$success("重命名成功！");
          const node = this.$refs.leftTree.getNode(this.selectionList[0].folderId);
          if (node) {
            node.data.workSpaceName = this.rowData.workSpaceName;
          }
          this.closeReNameDialog();
          this.getRightList();
        } else {
          return false;
        }
      });
    },
    closeReNameDialog() {
      this.reNameDialog = false;
      this.clearRowData();
    },
    clearRowData() {
      this.rowData = ROWDATA();
    },
    // 删除右侧选中
    deleteRightSelection() {
      const idList = [];
      const { selectionList } = this;
      const fileDel = selectionList.some(item => item.isSys === 1);
      if (fileDel) {
        return this.$message.warning("您选择的文件中包含没有删除权限的文件，请重新选择");
      }
      selectionList.forEach(ele => {
        idList.push(ele.folderId);
      });
      this.$confirm(`此操作将删除选中数据，是否继续？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
        closeOnPressEscape: false
      }).then(() => {
        workSpaceService.deleteRowData(idList).then(res => {
          if (res.result === "0") {
            this.$success("删除成功！");
            const node = this.$refs.leftTree.getNode(this.selectionList[0].folderId);
            if (node) {
              this.$refs.leftTree.remove(node);
            }
            this.selectionList = [];
            this.getRightList();
          }
        });
      });
    },
    // 右侧搜索
    filterKeyword(item, name) {
      const keyArr = ["folderName"];
      let flag = false;
      while (keyArr[0] && !flag) {
        if (item[keyArr.shift()].includes(name)) flag = true;
      }
      return flag;
    },
    className(row) {
      return tableRowIcon(row);
    },
    getIcon(level, data) {
      if (level === 1) {
        return require("@/CommonDP/assets/doc/folderParent.png");
      } else if (data.workSpaceType === 2) {
        return require("@/CommonDP/assets/workSpace/workspace.png");
      } else if (data.workSpaceType === 3) {
        return require("@/CommonDP/assets/workSpace/worksets.png");
      } else {
        return require("@/CommonDP/assets/projectMg/treeSysDoc.png");
      }
    }
  }
};
</script>

<style scoped lang="scss">
.workSpace {
  height: 100%;
  width: 100%;
  background-color: #fff;
  display: flex;

  .leftContent {
    width: 430px;
    height: 100%;
    border-right: 1px solid #ebefff;
    .buttons {
      width: 100%;
      height: 60px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #ebefff;
      padding: 10px 10px 10px 10px;
    }
    .tree {
      width: 100%;
      height: calc(100% - 70px);
      overflow-y: auto;
      margin-top: 10px;
      .left_tree_item{
        display: flex;
        align-items: center;
        position: relative;
        overflow: hidden;
        width:100%;
        padding-right:0px !important;
        .textAll{
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
  }
  .rightContent {
    width: calc(100% - 430px);
    padding: 0px 38px 10px 38px;

    .buttons {
      width: 100%;
      height: 60px;
      display: flex;
      align-items: center;
    }
    .titleContent {
      width: 100%;
      height: 60px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .titleContent_left {
        display: flex;
        justify-content: space-between;
        align-items: center;
        /deep/ .el-icon-return {
          background: url("../../../../../../CommonDP/assets/return.png") no-repeat;
          width: 14px;
          height: 12px;
        }
        /deep/ .el-icon-return:before {
          content: "替";
          font-size: 12px;
          visibility: hidden;
        }
      }
      .breadcrumb_list {
        margin-left: 10px;

        .active {
          color: var(--key-color);
        }
        span {
          font-size: 12px;
          cursor: pointer;
          color:  var(--info-color);
        }
        span:hover {
          color: var(--theme-color);
        }
        /deep/ .el-breadcrumb__inner{
          display: inline-block;
          max-width: 50px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
  }
  .workSpaceNameStyle{
    /deep/ .el-input__inner{
      padding-right: 48px;
    }
  }
}
</style>
